export default __webpack_public_path__ + "static/lutein-wet-wipe-promo-9ba0a8e044aa56c235d2370f0735d38e.jpg";